import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Reset/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import ResetTable from 'components/Web_User_Interface/1440p_Series/System/Reset/resetTable';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/System/Reset/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  ResetTable,
  PrimaryBox,
  BreadCrumbs,
  SEOHelmet,
  React
};